import { atom, useAtom } from 'jotai';
import { useCallback } from 'react';
import { SurgeryReferenceCompoundKeyFields } from 'api/hooks/useValidateSurgeryReference';
import { SelectFieldOption } from 'components/DropDown/ValidatingSelect';
import { DeliveryContentOption } from 'hooks/useDeliveryContentsOptions';

export type ReceiveDeliveryFields = SurgeryReferenceCompoundKeyFields & {
  receivedDate?: Date;
  supplierRep?: SelectFieldOption;
  orderNumber?: string;
  deliveryNumber?: string;
  deliveryContents?: DeliveryContentOption;
  numRoadCases?: number;
  numTubs?: number;
  numBoxes?: number;
  numPelicanCases?: number;
  numDoubleRoadCases?: number;
  shipper?: string;
  shipmentId?: string;
  patientInitials: string;
  createNewOrder: boolean;
};

export const INITIAL_RECEIVE_DELIVERY_FIELDS: ReceiveDeliveryFields = {
  orderNumber: '',
  deliveryNumber: '',
  surgeryReference: '',
  numRoadCases: 0,
  numTubs: 0,
  numBoxes: 0,
  numPelicanCases: 0,
  numDoubleRoadCases: 0,
  shipper: '',
  shipmentId: '',
  patientInitials: '',
  createNewOrder: false,
};

const receiveDeliveryFieldsAtom = atom(INITIAL_RECEIVE_DELIVERY_FIELDS);

export const useReceiveDeliveryFields = () => {
  const [fields, setFields] = useAtom(receiveDeliveryFieldsAtom);

  const setField = useCallback(
    <K extends keyof ReceiveDeliveryFields>(key: K, val: ReceiveDeliveryFields[K]) => {
      setFields(prevFields => ({ ...prevFields, [key]: val }));
    },
    [setFields],
  );

  const resetFields = useCallback(() => setFields(INITIAL_RECEIVE_DELIVERY_FIELDS), [setFields]);

  return { fields, setFields, setField, resetFields };
};
